export default __webpack_public_path__ + "static/media/Freebooter's Gloves of the Elder Bond.da90d261.jpg";